import {
    Chart,
    ArcElement,
    DoughnutController,
} from 'chart.js';

Chart.register(
    ArcElement,
    DoughnutController,
);


/**
 * Self Audit calc
 */
jQuery(document).ready(function () {
    if (jQuery('body:not(.et-fb-root-ancestor) .fdc-calc-form').length && jQuery('.final-score-percent').length) {

        let formIsSubmitted = false


        let score = 0,
            totalScore = 176

        window.scorePercent = 0;


        (function ($) {
            $.fn.animateNumbers = function (stop, commas, duration, ease) {
                return this.each(function () {
                    var $this = jQuery(this);
                    var isInput = $this.is('input');
                    var start = parseInt(isInput ? $this.val().replace(/,/g, "") : $this.text().replace(/,/g, ""));
                    var regex = /(\d)(?=(\d\d\d)+(?!\d))/g;
                    commas = commas === undefined ? true : commas;

                    // number inputs can't have commas or it blanks out
                    if (isInput && $this[0].type === 'number') {
                        commas = false;
                    }

                    jQuery({value: start}).animate({value: stop}, {
                        duration: duration === undefined ? 1000 : duration,
                        easing: ease === undefined ? "swing" : ease,
                        step: function () {
                            isInput ? $this.val(Math.floor(this.value)) : $this.text(Math.floor(this.value));
                            if (commas) {
                                isInput ? $this.val($this.val().replace(regex, "$1,")) : $this.text($this.text().replace(regex, "$1,"));
                            }
                        },
                        complete: function () {
                            if (parseInt($this.text()) !== stop || parseInt($this.val()) !== stop) {
                                isInput ? $this.val(stop) : $this.text(stop);
                                if (commas) {
                                    isInput ? $this.val($this.val().replace(regex, "$1,")) : $this.text($this.text().replace(regex, "$1,"));
                                }
                            }
                        }
                    });
                });
            };
        })(jQuery);


        // const formContainer = jQuery('.fdc-calc-form')


        jQuery('body.admin-bar').prepend('<div class="fdc-calc-debug"><div class="fdc-calc-score"></div><button type="button" class="et_pb_button">Validate page</button><button type="button" class="et_pb_button">Validate All</button></div>')

        const scoreContainer = jQuery('.fdc-calc-score')

        scoreContainer.html(`Debug score: 0`)


        /**
         * For debugging
         */
        jQuery(document).on('click', '.fdc-calc-debug button', function () {
            const currentPage = jQuery('.pagination-container').data('current-page'),
                type = jQuery(this).text(),
                checkContainer = type === 'Validate All' ? '.form-page[data-page]' : `.form-page[data-page="${currentPage}"]`,

                currentPageContainer = jQuery(checkContainer)


            const element = type === 'Validate All' ? 'input[required]' : '.wpforms-field-required'

            if (type === 'Validate All') {
                jQuery('.pagination-bullet.disabled').removeClass('disabled').prop('disabled', false)
            }

            currentPageContainer.find('.wpforms-field-required').each(function () {
                // console.log(jQuery(this))
                let container = jQuery(this),
                    firstInput = container.find('input[required]').first()

                if (!firstInput.length) {
                    firstInput = container
                }

                if (firstInput.attr('type') === 'radio' || firstInput.attr('type') === 'checkbox') {
                    firstInput.prop('checked', true).trigger('click').trigger('change')
                } else {
                    firstInput.val('1234').trigger('keyup').trigger('change')
                }

                jQuery('.wpforms-field-checkbox li').addClass('wpforms-selected')
                jQuery('.wpforms-field-checkbox input[type="checkbox"]').prop('checked', true).trigger('change')
            })
            setTimeout(() => {
                currentPageContainer.find('.wpforms-field-required').each(function () {
                    // console.log(jQuery(this))
                    let container = jQuery(this),
                        firstInput = container.find('input[required]').first()

                    if (!firstInput.length) {
                        firstInput = container
                    }

                    if (firstInput.attr('type') === 'radio' || firstInput.attr('type') === 'checkbox') {
                        firstInput.prop('checked', true).trigger('click').trigger('change')
                    } else {
                        firstInput.val('1234').trigger('keyup').trigger('change')
                    }
                })
            }, 100)

            // console.log(currentPage)

        })

        const calcScore = () => {

            score = 0
            window.scorePercent = 0

            function slugify(str) {
                str = str.replace(/^\s+|\s+$/g, ''); // trim leading/trailing white space
                str = str.toLowerCase(); // convert string to lowercase
                str = str.replace(/[^a-z0-9 -]/g, '') // remove any non-alphanumeric characters
                    .replace(/\s+/g, '-') // replace spaces with hyphens
                    .replace(/-+/g, '-'); // remove consecutive hyphens
                return str;
            }


            jQuery('div[data-fdc-calc-type] input').each((index, element) => {


                const input = jQuery(element),
                    item = input.parents('div[data-fdc-calc-type]'),
                    type = item.data('fdc-calc-type')


                switch (type) {
                    case 'yes-no':
                        if (input.prop('checked')) {
                            let val = input.val()

                            let points = val === 'Yes' ? parseInt(item.attr('data-fdc-calc-yes')) : 0
                            score = score + points
                        }
                        break;

                    case 'yes-no-improve':
                        if (input.prop('checked')) {
                            let val = input.val(),
                                points = 0

                            if (val === 'Yes') {
                                points = parseInt(item.attr('data-fdc-calc-yes'))
                            } else if (val === 'Yes, but it needs improvement' || val === 'Needs improvement') {
                                points = parseInt(item.attr('data-fdc-calc-improve'))
                            }


                            score = score + points
                        }
                        break;
                    case 'speed':
                    case 'ag-di':
                    case 'freq':
                        if (input.prop('checked')) {
                            let val = slugify(input.val())

                            score = score + parseInt(item.attr(`data-fdc-calc-${val}`))
                        }
                        break;

                    case 'count':
                        if (input.prop('checked')) {
                            score = score + parseInt(item.attr(`data-fdc-calc-p`))
                        }
                        break;
                }

            })


            scorePercent = Math.round((score / totalScore) * 100)


            scoreContainer.html(`Debug score: ${score} (${scorePercent}%)`)


            jQuery('.final-score input').val(`${score}/${totalScore}`)

            jQuery('.final-score-percent input').val(`${scorePercent}`)


        }


        jQuery(document).on('click change focusout keyup keydown enter backspace del', 'div[data-fdc-calc-type] input', calcScore)


        const initCalcPagination = () => {

            /**
             * TODO Remove in prod
             */
            if (typeof window.scroller !== 'undefined') {
                window.scroller.kill()
                console.log('init calc')
            }

            let bulletsContainer = [],
                noPages = 1;


            for (let i = 1; i < 15; i++) {
                const fields = jQuery(`.fdc-page-${i}`),
                    container = jQuery(`<div data-page="${i}" class="fdc-page-section form-page"/>`)

                if (fields.length) {
                    noPages++;

                    bulletsContainer[i] = `<button ${i === 1 ? '' : 'disabled'} type="button" data-page="${i}" class="pagination-bullet ${i === 1 ? 'active' : 'disabled'}"><span/></button>`
                    fields.wrapAll(container)

                    jQuery(`div[data-page="${i}"]`).prepend('<h3>Fill in the form below to complete the self audit</h3>')

                    if (i === 1) {
                        jQuery(`div[data-page="${i}"]`).addClass('show')
                    } else {
                        jQuery(`div[data-page="${i}"]`)//.addClass('slideOutRight')//.css('left','115%')
                    }

                }
            }
            /**
             * Wrap questions into pages that can be paginated
             */
            jQuery('.fdc-info-section').wrapAll(`<div data-page="${noPages}" class="last-page form-page  "/>`)

            /**
             * Add last page inputs to box
             */
            jQuery('.fdc-wrap-details, .fdc-calc-form .wpforms-submit-container').wrapAll('<div class="last-page-inputs"/>')


            bulletsContainer[noPages + 1] = `<button disabled type="button" data-page="${noPages}" class="pagination-bullet disabled"><span/></button>`


            /**
             * Wrap all pages into pagination container
             */
            jQuery('.fdc-page-section,.last-page').wrapAll('<div class="fdc-form-container loading-form"><div class="pages-container"/></div>')

            /**
             * Add pagination bullets and prev/next buttons at the bottom
             */
            jQuery('.fdc-form-container').append('<div data-current-page="1" class="pagination-container"/>')


            const paginationContainer = jQuery('.pagination-container')


            paginationContainer.append('<div class="pagination-bullets"/>')
            paginationContainer.append('<div class="prev-next"><button label="Previous" data-move-page="-1" disabled type="button" class="previous disabled">Previous</button><button label="Next" data-move-page="1" type="button" class="next">Next</button></div>')

            bulletsContainer.map(value => {
                jQuery('.pagination-bullets').append(value)
            })


            /**
             * Wrap diagram checklist on last page
             */
            jQuery('.fdc-awareness,.fdc-acquisition,.fdc-loyalty').wrapAll('<div class="diagram-checklist-col-1"/>')
            jQuery('.fdc-consideration,.fdc-retension').wrapAll('<div class="diagram-checklist-col-2"/>')
            jQuery('.diagram-checklist-col-1,.diagram-checklist-col-2').wrapAll('<div class="diagram-checklist"/>')


            /**
             * Wrap results sections
             */
            jQuery('.self-audit-result').wrapAll('<div id="self-audit-result"/>')


            /**
             * Add urls to the descriptions
             */

            jQuery('.wpforms-field-description').each(function () {
                const label = jQuery(this).siblings('label.wpforms-field-label')
                jQuery(this).html(urlify(jQuery(this).html())).detach()
                label.append(jQuery(this))
            })


            /**
             * Unhide form
             */
            jQuery('.d-none').removeClass('d-none')


            const setPageContainerHeight = (pageElement) => {

                // console.log(pageElement)
                if (typeof pageElement === 'undefined' || typeof pageElement.outerHeight === 'undefined') {
                    pageElement = jQuery('.form-page.show')
                }

                const pageHeight = pageElement.outerHeight(),
                    pageContainer = jQuery('.pages-container')


                pageContainer.css('height', pageHeight)
                // console.log(pageHeight)
            }


            const validationError = (currentPageContainer) => {


                let hasError = true,
                    scrollToError = wpforms.scrollToError //save the scrollToError for other forms then reset after validation check

                /**
                 * Override default scroll to so it includes the page menu
                 */
                wpforms.scrollToError = () => {
                    jQuery('html, body').animate({
                        scrollTop: currentPageContainer.find('.wpforms-field.wpforms-has-error').first().offset().top - 50 - jQuery('#header').outerHeight() - (jQuery('#wpadminbar').outerHeight() ?? 0)
                    }, 750, 'swing', setPageContainerHeight)
                };

                wpforms.checkForInvalidFields(jQuery('.fdc-calc-form >form'), currentPageContainer, (e) => {
                    hasError = false;
                })

                /**
                 * Reset page height
                 */
                setPageContainerHeight()

                wpforms.scrollToError = scrollToError


                // console.log(hasError)

                // if(jQuery('body.admin-bar').length){
                //     return false
                // }

                return hasError
            }


            const changePage = (newPage) => {
                const currentPage = paginationContainer.data('current-page'),
                    currentPageContainer = jQuery(`.pages-container .form-page[data-page="${currentPage}"]`),

                    previousButton = jQuery('.fdc-form-container button.previous'),
                    nextButton = jQuery('.fdc-form-container button.next'),
                    formContainer = jQuery('.pages-container'),
                    isNext = currentPage < newPage


                /**
                 * Check if page disabld so skip it
                 * @type {jQuery|HTMLElement|*}
                 */
                if (jQuery(`button.pagination-bullet[data-page="${newPage}"]`).hasClass('disabled-page')) {
                    if (isNext) {
                        newPage++
                    } else {
                        newPage--
                    }
                }


                const pageBullet = jQuery(`.pagination-bullet[data-page="${newPage}"]`)


                if (currentPage === newPage || (isNext && validationError(currentPageContainer))) {
                    return false;
                }


                const newPageContainer = jQuery(`.pages-container .form-page[data-page="${newPage}"]`)

                // currentPageContainer.toggle('fast').removeClass('show')
                // newPageContainer.toggle('fast').addClass('show')
// console.log(currentPageContainer)
                setPageContainerHeight(newPageContainer)
                // currentPageContainer.animate({ left: '-115%' }, 300).removeClass('show')
                // newPageContainer.animate({ left: '0px' }, 300).addClass('show')

                if (isNext) {
                    currentPageContainer.addClass('slideOutLeft').removeClass('slideInRight slideInLeft show')
                    newPageContainer.addClass('slideInRight show').removeClass('slideOutRight slideOutLeft')
                    jQuery(`.pagination-bullet[data-page="${newPage}"]`).removeClass('disabled').prop('disabled', false)
                } else {
                    currentPageContainer.addClass('slideOutRight').removeClass('slideInRight slideInLeft show')
                    newPageContainer.addClass('slideInLeft show').removeClass('slideOutRight slideOutLeft')

                }
                jQuery('html, body').animate({
                    scrollTop: formContainer.offset().top - 50 - jQuery('#header').outerHeight() - (jQuery('#wpadminbar').outerHeight() ?? 0)
                }, 0);


                // console.log({noPages, newPage})

                paginationContainer.data('current-page', newPage)


                jQuery('.pagination-bullet').not(pageBullet).removeClass('active')
                pageBullet.addClass('active')

                if (newPage === 1) {
                    previousButton.addClass('disabled').prop('disabled', true)
                } else {
                    previousButton.removeClass('disabled').prop('disabled', false)
                }

                if (newPage === noPages) {
                    nextButton.addClass('disabled').prop('disabled', true)
                } else {
                    nextButton.removeClass('disabled').prop('disabled', false)
                }


            }

            /**
             * Override default scroll to so it includes the page menu
             */
            wpforms.scrollToError = () => {
                if (jQuery('.wpforms-error').length) {


                    const errorPage = jQuery('.wpforms-error').first().parents('.form-page').data('page')

                    changePage(errorPage)

                    setTimeout(() => {
                        jQuery('html, body').animate({
                            scrollTop: jQuery('.wpforms-error').first().offset().top - 50 - jQuery('#header').outerHeight() - (jQuery('#wpadminbar').outerHeight() ?? 0)
                        }, 750)
                    }, 1000)

                }
            };

            /**
             * Check if conditional fields are required
             * @type {MutationObserver}
             */
            const observer = new MutationObserver(function (mutations) {
                // console.log(mutations)
                mutations.forEach(function (mutation) {
                    if (jQuery(mutation.target).hasClass('wpforms-conditional-show')) {
                        jQuery(mutation.target).find('input').prop('required', true)
                        jQuery(mutation.target).find('ul,input[type="text"],input[type="number"]').addClass('wpforms-field-required')
                    } else {
                        jQuery(mutation.target).find('input').prop('required', false)
                        jQuery(mutation.target).find('ul,input[type="text"],input[type="number"]').removeClass('wpforms-field-required')
                    }
                });
            });

            jQuery('.wpforms-conditional-field').each(function () {
                observer.observe(jQuery(this)[0], {
                    attributes: true,
                    attributeFilter: ['class']
                });
            })


            jQuery(document).on('click', '.pagination-bullet', function () {
                const
                    bullet = jQuery(this),
                    newPage = bullet.data('page')

                changePage(newPage)
            })

            jQuery(document).on('click', '.fdc-form-container button.previous,.fdc-form-container button.next', function () {
                const
                    button = jQuery(this),
                    movePage = button.data('move-page'),
                    currentPage = paginationContainer.data('current-page')

                changePage(currentPage + movePage)
            })

            setPageContainerHeight()


            // jQuery(document).on('change focusout keyup keydown enter backspace', '.form-page.show input', setPageContainerHeight)

            jQuery(document).on('click change focusout keyup keydown enter backspace del', '.form-page.show input', () => {
                setPageContainerHeight()
                setTimeout(setPageContainerHeight, 1000)
            })


            jQuery(document).on('click', '.fdc-calc-form form button[type="submit"]', function () {
                setTimeout(setPageContainerHeight, 50)
            })


            jQuery(window).resize(setPageContainerHeight)

            // setTimeout(()=>{
            //     jQuery('.fdc-form-container.loading-form').removeClass('loading-form')
            // },400)


            /**
             * Disable / enable pages if no inputs are visible
             */
            jQuery(document).on('wpformsProcessConditionals', function () {
                jQuery('.fdc-page-section.form-page').each(function () {
                    const pageContainer = jQuery(this),
                        pageNumber = pageContainer.data('page'),
                        totalQuestions = pageContainer.find('.wpforms-field').length,
                        conditionalQuestions = pageContainer.find('.wpforms-conditional-field').length,
                        shownQuestions = pageContainer.find('.wpforms-conditional-show').length,
                        hiddenQuestions = pageContainer.find('.wpforms-conditional-hide').length


                    if (totalQuestions === conditionalQuestions && conditionalQuestions > 0 && shownQuestions === 0) {
                        // console.log({pageNumber, totalQuestions,conditionalQuestions, shownQuestions, hiddenQuestions},)
                        jQuery(`button.pagination-bullet[data-page="${pageNumber}"]`).hide().addClass('disabled-page')
                    } else {
                        jQuery(`button.pagination-bullet[data-page="${pageNumber}"]`).show().removeClass('disabled-page')
                    }
                })
            })


            /**
             * Warn user before leaving page if they have answered any question
             */
            window.onbeforeunload = function (e) {

                if (score > 0 && !formIsSubmitted) {

                    let confirmationMessage = 'Are you sure you want to leave? Contact our team to help you with your audit.';

                    e.preventDefault();
                    (e || window.event).returnValue = confirmationMessage

                    return confirmationMessage
                }


            }


        }

        initCalcPagination()


        function urlify(text) {
            var urlRegex = /(https?:\/\/[^\s]+)/g;
            return text.replace(urlRegex, function (url) {
                return '<a target="_blank" href="' + url + '">' + url.replace('https://', '').replace(/\/$/, "") + '</a>';
            })
            // or alternatively
            // return text.replace(urlRegex, '<a href="$1">$1</a>')
        }


        window.resultChartJs = () => {


            const radiusBackground = {
                id: 'radiusBackground',
                beforeDraw(chart, args, options) {
                    const {ctx, chartArea: {left, top, width, height}} = chart;

                    const
                        controller = chart._sortedMetasets[0].controller,

                        outerRadius = controller.outerRadius,
                        innerRadius = controller.innerRadius,
                        radiusLength = (outerRadius - innerRadius) / controller._getVisibleDatasetWeightTotal();


                    ctx.beginPath();
                    ctx.arc(width / 2, height / 2, (outerRadius - (radiusLength / 2)), 0, 2 * Math.PI, false);
                    ctx.lineWidth = radiusLength - 1;
                    // line color
                    ctx.strokeStyle = '#f0f2f8';
                    ctx.stroke();
                    ctx.restore();

                }
            };

            const ctx = document.getElementById('result-counter');
            window.resultChart = new Chart(ctx, {
                type: 'doughnut',
                plugins: [radiusBackground],
                options: {
                    cutout: '80%',
                    responsive: true,
                    maintainAspectRatio: true,
                    hover: {mode: null},
                    layout: {
                        padding: {
                            bottom: 1
                        }
                    },
                },
                data: {
                    datasets: [{
                        data: [scorePercent, 100 - scorePercent],
                        backgroundColor: ['#004af5', 'transparent'],
                        borderAlign: 'center',
                        borderWidth: 0,
                    }]
                },

            });
        }


        /**
         * Form successfully submitted. Hide calculator and show results.
         */
        jQuery('.fdc-calc-form >form').on('wpformsAjaxSubmitSuccess', (e, response) => {

            // const animateScrollTop = wpforms.animateScrollTop
            //
            // wpforms.animateScrollTop = ()=>{}
            formIsSubmitted = true;

            jQuery('#self-audit, #self-audit-header').hide()
            jQuery('#self-audit-result').fadeIn(500, () => {

                jQuery('#result-score').animateNumbers(scorePercent);
                resultChartJs()
            })
            jQuery('html, body').animate({
                scrollTop: jQuery('#self-audit-result').offset().top - 50 - jQuery('#header').outerHeight() - (jQuery('#wpadminbar').outerHeight() ?? 0)
            }, 0);


            // wpforms.animateScrollTop = animateScrollTop
        });

    }
})
